module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Book.7cb80078.woff2";